import React, { useEffect, useState } from 'react';
import { StyledCardsContainer } from '@/operator/components/modules/AuthPage/setup/signin/Styles';
import AddOrg from '@/operator/components/modules/organizations/AddOrg';
import Org from '@/operator/components/modules/organizations/Org';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useTranslation } from 'react-i18next';
import { searchOrg } from './utils';
import process from 'process';

import Stack from '@mui/material/Stack';
import useAuth from 'Modules/firebase/use-auth';
import { useGetUserOrgsQuery } from 'generated/graphql';
import { UserOrg } from 'graphql/types/userOrgs';
import Loader from 'Components/Loader';

const tenantURLDomain = process.env.NEXT_PUBLIC_TENANT_URL_DOMAIN;
const pathURLSuffix = '.launchoperator.com';

export const Content = (): JSX.Element => {
    const { t } = useTranslation();

    const [search, setSearch] = useState('');
    const [orgsList, setOrgsList] = useState<UserOrg[]>([]);
    const { user } = useAuth();

    const orgs = searchOrg(search, orgsList);

    const { data, loading } = useGetUserOrgsQuery({
        variables: {
            email: user?.email,
        },
        skip: !user?.email,
    });

    useEffect(() => {
        if (data?.userOrganizations.length && !orgsList.length) {
            setOrgsList(data?.userOrganizations);
        }
    }, [data?.userOrganizations]);

    if (loading) {
        return <Loader message="Loading organizations" />;
    }

    return (
        <Stack spacing={2}>
            {orgsList.length >= 5 ? (
                <OutlinedInput
                    placeholder={
                        t('ExistingOrg.SearchBar.Placeholder') as string
                    }
                    id="outlined-input-org-search"
                    startAdornment={
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    }
                    aria-describedby="outlined-weight-helper-text"
                    inputProps={{
                        'aria-label': 'orgs',
                    }}
                    sx={{
                        backgroundColor: 'white',
                        width: '437px',
                        height: '55px',
                        marginBottom: '10px',
                        '@media screen and (max-width: 1000px)': {
                            width: '400px',
                        },
                        '@media (width > 415px) and (width <= 850px)': {
                            marginTop: '40px',
                            width: '90%',
                        },
                        '@media (width <= 460px)': {
                            marginTop: '40px',
                            width: '400px',
                        },
                    }}
                    onChange={(e) => setSearch(e.target.value)}
                />
            ) : null}
            <StyledCardsContainer>
                {orgs.map(({ displayName, tenantUrl, instanceId }) => (
                    <Org
                        key={tenantUrl}
                        orgId={instanceId}
                        orgName={displayName}
                        orgTenantUrl={tenantUrl}
                        orgDomain={`${tenantUrl}${pathURLSuffix}`}
                        orgUrl={`https://${tenantUrl}.${tenantURLDomain}`}
                    />
                ))}
            </StyledCardsContainer>
            <AddOrg />
        </Stack>
    );
};

export default Content;
